import '@babel/polyfill';
import 'url-polyfill'; // TODO: Remove it after start using core-js@3 polyfill
import { render } from 'react-dom';
import '@saucelabs/sl-style-main';
import '@saucelabs/sl-util-sentry';
import config from '@saucelabs/sl-util-config';
import * as backtrace from 'backtrace-js';

import router from './router';


config.load(window.WEB_SETTINGS);
render(router, document.getElementById('app'));

if (config?.backtrace?.enabled) {
  backtrace.initialize({
    endpoint: config.backtrace.endpoint,
    token: config.backtrace.token,
    attributes: {
      version: config.version,
      environment: config.env,
      branch: config.branch,
      sha: config.sha,
    },
  });
}

import '@saucelabs/sl-style-font/lib/fonts.css'; // eslint-disable-line
